<template>

    <div class="tw-m-5">

        <div class="tw-mb-1 tw-text-gray-600 label">{{ label }}</div>

        <small v-if="instruction"
               class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted">{{ instruction }}</small>

        <div class="inline-flex mt-1">

            <button
                v-for="item in items"
                :class="{ selected: item.value === currentValue }"
                class="focus:tw-outline-none"
                @click="setValue(item.value)">{{ item.label }}
            </button>

        </div>

    </div>

</template>

<script>

export default {

    props: {

        label: {
            type: String,
            required: true,
        },

        instruction: {
            type: String,
        },

        options: {
            type: Object,
            required: true,
        },
        optionsProperty: {
            required: true,
        },

        items: {
            type: Array,
            required: true,
        },

        defaultValue: {},
    },

    methods: {

        setValue(value) {
            // Set in options.
            this.$set(this.options, this.optionsProperty, value);

            // Emit for whoever wants to know.
            this.$emit('valueChange');
        }

    },

    computed: {

        currentValue() {
            // Get value from options.
            let value = this.options[this.optionsProperty];

            // Use value of default value?
            return value === undefined ? this.defaultValue : value;
        },

    },

}

</script>

<style lang="scss" scoped>

button {
    @apply tw-bg-transparent tw-text-blue-500 tw-py-2 tw-px-4 tw-border tw-border-blue-400 tw-transition;
    cursor: pointer;

    &:not(:last-child) {
        @apply tw-border-r-0;
    }

    &.selected {
        @apply tw-bg-blue-400 tw-text-white tw-border-transparent;

        &:hover {
            @apply tw-bg-blue-400;
        }
    }

    &:hover {
        @apply tw-bg-blue-100;
    }

}

</style>
